/** Bandera de Argentina, simplificada: el sol de mayo como disco liso. */
export function ArFlag({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size * 0.7} viewBox="0 0 28 20" aria-hidden="true" focusable="false">
      <rect width="28" height="20" fill="#74ACDF" />
      <rect y="6.7" width="28" height="6.6" fill="#FFFFFF" />
      <circle cx="14" cy="10" r="2.1" fill="#F6B40E" />
    </svg>
  );
}
